import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux'
import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk'

import reducers from './Reducers'

import App from './App';

import GA4React from "ga-4-react";

const store = createStore(reducers, compose(applyMiddleware(thunk)))

const ga4react = new GA4React('G-LPMJS4VKEW')

setTimeout(() => {
  ga4react.initialize().then((ga4) => {
    ga4.pageview('path')
    ga4.gtag('event','pageview','path')
  }).catch(console.error)
}, 0);
  
const root = document.getElementById('root');

if (root) {
  ReactDOM.render(
    <Provider store={store}>
      <App />
    </Provider>,
    root
  );
} else {
  console.error("Root element not found!");
}